import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {

  },
  rowContainer: {
    display: 'flex',
    justifyContent: 'center',
    borderBottom: '1px solid',
    borderColor: 'common.border',
  },
  headerContainer: {
    backgroundColor: 'primary.main',
  },
  headerLabel: {
    fontSize: 18,
    fontWeight: '700',
    color: 'secondary.main',
    textAlign: 'center',
    paddingY: '7px',
  },
  rowItem: {
    minHeight: '100%',
    borderRight: '0.5px solid',
    borderLeft: '0.5px solid',
    borderColor: 'common.border',
    display: 'flex',
    alignItems: 'center',
  },
  rowItemLabel: {
    padding: '12px',
    fontSize: 14,
    color: 'common.grey800',
  },
  firstItem: {
    fontWeight: '500',
  },
  recommendedContainer: {
    backgroundColor: 'payment.recommendedColor',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingY: '7px',
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
  },
  star: {
    color: 'common.yellow700',
    mr: '8px',
  },
  recommendedLabel: {
    color: 'secondary.main',
    fontSize: 14,
    fontWeight: '600',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
